import { call, put, takeEvery } from 'redux-saga/effects';
import * as actions from './_actions';
import * as types from './_actionTypes';

function* fetchAvailableQuizzesSaga() {
  try {
    const mockQuizzes = [
      {
        id: 1,
        title: 'Programming Fundamentals Quiz',
        subject: 'Computer Science',
        questions: 5,
        timeLimit: 600, // 10 minutes
        attempts: 0,
        maxAttempts: 3,
        passingScore: 60,
        isAvailable: true,
        dueDate: '2024-02-01T23:59:59Z'
      },
      {
        id: 2,
        title: 'Data Structures Assessment',
        subject: 'Computer Science',
        questions: 8,
        timeLimit: 900, // 15 minutes
        attempts: 1,
        maxAttempts: 2,
        passingScore: 70,
        isAvailable: true,
        dueDate: '2024-02-05T23:59:59Z'
      },
      {
        id: 3,
        title: 'Algorithms Quiz',
        subject: 'Computer Science',
        questions: 6,
        timeLimit: 720, // 12 minutes
        attempts: 0,
        maxAttempts: 3,
        passingScore: 65,
        isAvailable: false,
        dueDate: '2024-02-10T23:59:59Z'
      }
    ];
    
    yield put(actions.fetchAvailableQuizzesSuccess(mockQuizzes));
  } catch (error) {
    yield put(actions.fetchAvailableQuizzesFailure(error.message));
  }
}

function* startQuizSaga(action) {
  try {
    const mockQuizData = {
      id: action.payload,
      title: 'Programming Fundamentals Quiz',
      timeLimit: 600,
      questions: [
        {
          id: 1,
          question: 'What is a variable in programming?',
          options: ['A storage location', 'A function', 'A loop', 'A condition'],
          correct: 0
        },
        {
          id: 2,
          question: 'Which of the following is a programming language?',
          options: ['HTML', 'CSS', 'JavaScript', 'All of the above'],
          correct: 2
        },
        {
          id: 3,
          question: 'What does IDE stand for?',
          options: ['Integrated Development Environment', 'Internet Data Exchange', 'Internal Data Engine', 'Interactive Design Editor'],
          correct: 0
        },
        {
          id: 4,
          question: 'What is the purpose of a compiler?',
          options: ['To debug code', 'To translate code to machine language', 'To format code', 'To backup code'],
          correct: 1
        },
        {
          id: 5,
          question: 'Which data type stores whole numbers?',
          options: ['String', 'Boolean', 'Integer', 'Float'],
          correct: 2
        }
      ]
    };
    
    yield put(actions.startQuizSuccess(mockQuizData));
  } catch (error) {
    yield put(actions.startQuizFailure(error.message));
  }
}

function* submitQuizSaga(action) {
  try {
    yield new Promise(resolve => setTimeout(resolve, 1000));
    
    const { quizId, answers } = action.payload;
    
    // Mock grading
    const correctAnswers = [0, 2, 0, 1, 2]; // Correct answers for mock quiz
    let score = 0;
    
    correctAnswers.forEach((correct, index) => {
      if (answers[index + 1] === correct) {
        score++;
      }
    });
    
    const percentage = Math.round((score / correctAnswers.length) * 100);
    const result = {
      quizId,
      score: percentage,
      passed: percentage >= 60,
      totalQuestions: correctAnswers.length,
      correctAnswers: score,
      submittedAt: new Date().toISOString(),
      title: 'Programming Fundamentals Quiz'
    };
    
    yield put(actions.submitQuizSuccess(result));
  } catch (error) {
    yield put(actions.submitQuizFailure(error.message));
  }
}

function* fetchQuizResultsSaga() {
  try {
    const mockResults = [
      {
        id: 1,
        quizId: 1,
        title: 'Programming Fundamentals Quiz',
        score: 85,
        passed: true,
        totalQuestions: 5,
        correctAnswers: 4,
        submittedAt: '2024-01-15T14:30:00Z'
      },
      {
        id: 2,
        quizId: 2,
        title: 'Data Structures Assessment',
        score: 72,
        passed: true,
        totalQuestions: 8,
        correctAnswers: 6,
        submittedAt: '2024-01-14T16:45:00Z'
      }
    ];
    
    yield put(actions.fetchQuizResultsSuccess(mockResults));
  } catch (error) {
    yield put(actions.fetchQuizResultsFailure(error.message));
  }
}

function* studentQuizzesSaga() {
  yield takeEvery(types.FETCH_AVAILABLE_QUIZZES_REQUEST, fetchAvailableQuizzesSaga);
  yield takeEvery(types.START_QUIZ_REQUEST, startQuizSaga);
  yield takeEvery(types.SUBMIT_QUIZ_REQUEST, submitQuizSaga);
  yield takeEvery(types.FETCH_QUIZ_RESULTS_REQUEST, fetchQuizResultsSaga);
}

export default studentQuizzesSaga;